import {
  DELETE_BLACK_LIST_ERROR,
  DELETE_BLACK_LIST_REQUEST,
  DELETE_BLACK_LIST_SUCCESS,
  GET_BLACK_LIST_ERROR,
  GET_BLACK_LIST_REQUEST,
  GET_BLACK_LIST_SUCCESS,
  POST_BLACK_LIST_ERROR,
  POST_BLACK_LIST_REQUEST,
  POST_BLACK_LIST_SUCCESS,
} from './constants';

export const getBlackListRequest = () => ({
  type: GET_BLACK_LIST_REQUEST,
});

export const getBlackListSuccess = (reports: any) => ({
  type: GET_BLACK_LIST_SUCCESS,
  payload: reports,
});

export const getBlackListError = (error: Error) => ({
  type: GET_BLACK_LIST_ERROR,
  payload: { error },
});

export const postBlackListRequest = (body: any) => ({
  type: POST_BLACK_LIST_REQUEST,
  payload: body,
});

export const postBlackListSuccess = () => ({
  type: POST_BLACK_LIST_SUCCESS,
});

export const postBlackListError = (error: Error) => ({
  type: POST_BLACK_LIST_ERROR,
  payload: { error },
});

export const deleteBlackListRequest = (id: any) => ({
  type: DELETE_BLACK_LIST_REQUEST,
  payload: id,
});

export const deleteBlackListSuccess = () => ({
  type: DELETE_BLACK_LIST_SUCCESS,
});

export const deleteBlackListError = (error: Error) => ({
  type: DELETE_BLACK_LIST_ERROR,
  payload: { error },
});

export type Actions =
  | ReturnType<typeof deleteBlackListRequest>
  | ReturnType<typeof deleteBlackListSuccess>
  | ReturnType<typeof deleteBlackListError>
  | ReturnType<typeof postBlackListRequest>
  | ReturnType<typeof postBlackListSuccess>
  | ReturnType<typeof postBlackListError>
  | ReturnType<typeof getBlackListRequest>
  | ReturnType<typeof getBlackListSuccess>
  | ReturnType<typeof getBlackListError>;
